import { Type } from 'class-transformer';
import {
  IsDate,
  IsDefined,
  IsInt,
  IsString,
  Length,
  Max,
  Min
} from 'class-validator';
import { DriverInformationBaseDto } from './driver-information-base.dto';

/**
 * DTO object for creation of Driver Assignment to Merchant.
 */
export class DriverAssignmentForCreateDto extends DriverInformationBaseDto {
  @IsInt()
  @Min(1)
  @Max(2147483647) // MySql INT(11) max value
  @IsDefined()
  driverId: number;

  @IsString()
  @IsDefined()
  @Length(1, 250)
  driverLastName: string;

  @IsString()
  @IsDefined()
  @Length(1, 50)
  driverPhoneNumber: string;

  @IsInt()
  @Min(1)
  @Max(2147483647) // MySql INT(11) max value
  @IsDefined()
  locationId: number;

  @IsDate()
  @Type(() => Date)
  startTime: Date;

  @IsDate()
  @Type(() => Date)
  endTime: Date;
}
